var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/consumer-button.tsx";
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { prepareRequest } from 'soapbox/actions/consumer-auth';
import { IconButton, Tooltip } from 'soapbox/components/ui';
import { useAppDispatch } from 'soapbox/hooks';
import { capitalize } from 'soapbox/utils/strings';
const messages = defineMessages({
  tooltip: {
    "id": "oauth_consumer.tooltip",
    "defaultMessage": "Sign in with {provider}"
  }
});
/** Map between OAuth providers and brand icons. */

const BRAND_ICONS = {
  twitter: require('@tabler/icons/brand-twitter.svg'),
  facebook: require('@tabler/icons/brand-facebook.svg'),
  google: require('@tabler/icons/brand-google.svg'),
  microsoft: require('@tabler/icons/brand-windows.svg'),
  slack: require('@tabler/icons/brand-slack.svg'),
  github: require('@tabler/icons/brand-github.svg')
};

/** OAuth consumer button for logging in with a third-party service. */
const ConsumerButton = _ref => {
  let {
    provider
  } = _ref;
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const icon = BRAND_ICONS[provider] || require('@tabler/icons/key.svg');

  const handleClick = () => {
    dispatch(prepareRequest(provider));
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    text: intl.formatMessage(messages.tooltip, {
      provider: capitalize(provider)
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    theme: "outlined",
    className: "p-2.5",
    iconClassName: "w-6 h-6",
    src: icon,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }));
};

export default ConsumerButton;